import { GetServerSideProps } from 'next';
import React, { FC } from 'react';

import { ComponentOverview } from 'components/component-overview/ComponentOverview';

const Search: FC = () => {
    return <ComponentOverview />;
};

export const getServerSideProps: GetServerSideProps = async () => {
    return {
        props: {},
    };
};

export default Search;
